import logo from './logo.svg';
import './App.css';
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import spec from "./swagger.yaml"

import { useMsal,useIsAuthenticated, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

function App() {
  var url = window.location.protocol + '//' + window.location.host + spec;
  var displayURL = false;
  console.log(url);

  const { instance,accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => console.error(e));
  };

  const handleLogout = () => {
    instance.logoutRedirect().catch(e => console.error(e));
  };
    console.log("Is Authenticated:", isAuthenticated);
    console.log("Accounts:", accounts);

  return (
    <div>
      <AuthenticatedTemplate>
        <header className="app-header">
          <div className="header-container">
            <div className="header-left">
              <img src="/logo-white.png" alt="Ostrum Swagger UI" className="app-logo" />
              <p className="app-subtitle">API Documentation Portal</p>
            </div>
            
            <div className="header-right">
              <div className="user-info">
                <span className="user-icon">👤</span>
                <div className="user-details">
                  <p className="user-name">{accounts && accounts[0]?.name ? accounts[0].name : 'User'}</p>
                  <p className="user-email">{accounts && accounts[0]?.username ? accounts[0].username : 'Authenticated'}</p>
                </div>
              </div>
              <button className="sign-out-button" onClick={handleLogout}>
                <span className="button-icon">🚪</span>
                Sign Out
              </button>
            </div>
          </div>
        </header>
        <SwaggerUI
          url={url}
          displayUrl={displayURL}
          docExpansion="none"
          defaultModelsExpandDepth={-1}
          tryItOutEnabled={true}
          supportedSubmitMethods={["get", "post", "put", "delete"]}
          showExtensions={false}
          showCommonExtensions={false}
          displayOperationId={false}
          displayRequestDuration={false}
        />
      </AuthenticatedTemplate>
      
      <UnauthenticatedTemplate>
        <div className="login-page">
          <div className="login-container">
            <div className="login-content">
              <div className="login-header">
              <img src="/logo-white.png" alt="Ostrum Swagger UI" className="login-logo" />
             
              </div>
              
              <div className="login-body">
                 <h3 class="login-title">API Documentation Portal</h3>
                <p className="login-description">Sign in with your Ostrum Microsoft account to access the API documentation</p>
                <button className="login-button microsoft-button" onClick={handleLogin}>
                  <span className="button-icon">🔐</span>
                  Sign In
                </button>
              </div>
              
              <div className="login-footer">
                <p className="footer-text">
                  Copyright © {new Date().getFullYear()}  
                  <a href="https://www.ostrumtech.com/" target="_blank" rel="noopener noreferrer"> Ostrum Tech Limited</a>
                  . All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
}

export default App;
